import { render } from "./pending-interviews.vue?vue&type=template&id=0c7eb2e7&ts=true"
import script from "./pending-interviews.vue?vue&type=script&lang=ts"
export * from "./pending-interviews.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__